export const appVersion = __APP_VERSION__;
export const buildTime = __BUILD_TIME__;

function formattedBuildTime(): string {
  return new Intl.DateTimeFormat("de-DE", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(buildTime));
}

export function BuildInfo({ compact = false }: { compact?: boolean }) {
  return (
    <span className="build-info" title={`Build erstellt: ${buildTime}`}>
      {appVersion}
      {compact ? null : ` · Build ${formattedBuildTime()}`}
    </span>
  );
}
